/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface IAddCommentResponse extends IMessage {
	commentThreadId: string;
	commentId: string;
	createdAt: string;
}

export default class AddCommentResponse extends Message {
	public readonly createdAt: Date;

	public static readonly DESCRIPTOR_NAME: string = 'CommentsV2AddCommentResponse';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			commentThreadId: {
				type: 'string',
				id: 1
			},
			commentId: {
				type: 'string',
				id: 2
			},
			createdAt: {
				type: 'string',
				id: 3
			}
		}
	};

	public constructor( public readonly commentThreadId: string, public readonly commentId: string, createdAt: string ) {
		super();

		this.createdAt = new Date( createdAt );
	}

	public toJSON(): IAddCommentResponse {
		return {
			commentThreadId: this.commentThreadId,
			commentId: this.commentId,
			createdAt: this.createdAt.toISOString()
		};
	}

	public static fromJSON( data: IAddCommentResponse ): AddCommentResponse {
		return new AddCommentResponse( data.commentThreadId, data.commentId, data.createdAt );
	}
}
